import { VApplication } from "../../../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { BlockListUserPageService } from "../../../../../services";

const MODULE_NAME = "profile.machines.states.WHITELISTUser";
const log: any = LoggerModule?.getInstance();

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    "services.BlockListUserPageService"
  ) as BlockListUserPageService;
};

export const whitelistUser = async (context: any, event: any) => {
  const currentState = "WHITELIST_USER";
  const method = "revokeCred";

  return new Promise(async (resolve, reject) => {
    try {
      log.blue(MODULE_NAME, "context: ", context, "event: ", event);
      const srv = getSrv();
      const content = await srv.whiteListUser(event?.payload);

      if (content) {
        return resolve({
          key: "WHITELIST_USER_SUCCESS",
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = "Page content not found";
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: "WHITELIST_USER_FAILED",
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: "WHITELIST_USER_FAILED",
        value: err?.message,
      });
    }
  });
};
